import React, { useMemo } from 'react'
import { ModalProps } from './types'
import Svg from '../svg/svg'

import ItemButtons from './ItemButtons'

export const Modal = ({
   isModalVisible,
   closeModal,
   title,
   children,
   maxWidth,
   zIndex,
   marginTop,
   marginLeft,
   itemButtons = [],
   permissions = [],
   left,
   stickyHeader = false,
   headerColour,
   closeSvgFill,
   hideCloseIcon,
   displayOverlay = true,
   modalInnerStyles,
   isItemModal,
}: ModalProps) => {
   const isModalClosed = useMemo(
      () => (isModalVisible ? '' : 'modal-hidden'),
      [isModalVisible]
   )

   const isItemButtons = useMemo(() => itemButtons?.length > 0, [itemButtons])

   return (
      <>
         <div
            id="modalOverlay"
            className={displayOverlay ? `modal-overlay ` + isModalClosed : ''}
            style={{ zIndex }}
         />
         <div
            id="modalWrapper"
            className={displayOverlay ? `modal-wrapper ` + isModalClosed : ''}
            style={{ zIndex, marginTop, marginLeft, left }}
         >
            <div
               className="modal-inner"
               style={{ maxWidth, ...modalInnerStyles }}
            >
               <header
                  className={`modal-header ${
                     isItemModal ? 'item-modal-header' : ''
                  }`}
                  style={{
                     zIndex: stickyHeader ? 999 : 0,
                     backgroundColor: headerColour,
                  }}
               >
                  <h2
                     className="title"
                     aria-label={title}
                     style={{
                        color: headerColour === '#FFCA05' ? 'black' : '#1a4d80',
                     }}
                  >
                     {title}
                  </h2>

                  {isItemButtons && (
                     <ItemButtons
                        permissions={permissions}
                        itemButtons={itemButtons}
                        isItemModal={isItemModal}
                     />
                  )}

                  {!hideCloseIcon && (
                     <button
                        type="reset"
                        onClick={() => closeModal()}
                        className="close-button"
                        title="Close modal"
                     >
                        <Svg
                           id="close"
                           fill={closeSvgFill}
                           overrideViewBox="0 0 6 6"
                           width={14}
                           height={14}
                        />
                     </button>
                  )}
               </header>
               <main className="modal-content">{children}</main>
            </div>
         </div>
      </>
   )
}
